export const COLUMN_ID = 'id';
export const COLUMN_PREVIEW = 'preview';
export const COLUMN_NAME = 'name';
export const COLUMN_APPLICATION = 'application';
export const COLUMN_DOMAIN = 'domain';
export const COLUMN_LOCALE = 'locale';
export const COLUMN_FLOW = 'conversionPageFlow';
export const COLUMN_PLATFORM = 'platform';
export const COLUMN_USED_IN_ADS = 'usedInAds';
export const COLUMN_TAGS = 'tags';
export const COLUMN_CREATED_DATE = 'createdDate';
